<template>
  <div class="spacer">SPACER</div>
</template>

<script>
export default {
  name: 'ContentSpacer',

  props: [
    'obj'
  ]
}
</script>

<style scoped>
  .spacer {
    padding: 5px;

    border: dashed 1px #CCC;
    text-align: center;
  }
</style>
